import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { useShowErrorToast } from '@utils/formHelpers';
import { DefaultApiResp } from '@root/globalTypes';
import { queryFetch } from '@services/api';
import { useQueryParams } from '@hooks/queryParams';

export const useClearAllInventoryRoutePoints = ({
  callback,
}: {
  callback: (data: DefaultApiResp) => void;
}) => {
  const {
    params: { routeId },
  } = useQueryParams();

  const queryClient = useQueryClient();
  const { showErrorToast } = useShowErrorToast();
  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<DefaultApiResp> =>
      queryFetch({
        url: `routes_planner/${routeId}/clear_points`,
        opt: { method: 'DELETE' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await queryClient.refetchQueries({
        queryKey: queryKeys.inventoryAvailable,
      });
      await queryClient.refetchQueries({
        queryKey: queryKeys.inventoryRequested,
      });
      await queryClient.refetchQueries({ queryKey: [...queryKeys.inventoryRoutes, routeId] });
      await queryClient.refetchQueries({ queryKey: queryKeys.dropdowns.routes });
    },
    onSettled: (data) => {
      if (!data) return;
      const { success, errors } = data as DefaultApiResp;
      if (errors) showErrorToast(errors);
      if (success) callback(data as DefaultApiResp);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
